<template>
  <div :class="brandClass" :style="brandStyle">
    <div class="auth-brand__logo-wrap">
      <img :src="data.logo" :alt="logoAlt" class="auth-brand__logo" />
    </div>
    <h3 class="auth-brand__title">{{ data.title }}</h3>
    <p v-if="data.subtitle" class="auth-brand__subtitle">
      {{ data.subtitle }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";

defineOptions({
  inheritAttrs: false,
});

type AuthBrandData = {
  logo: string;
  title: string;
  subtitle?: string;
};

const props = withDefaults(
  defineProps<{
    data: AuthBrandData;
    logoAlt?: string;
    titleColor?: string;
    subtitleColor?: string;
    subtitleSize?: string;
    gap?: string;
    marginTop?: string;
    logoSpacing?: string;
  }>(),
  {
    logoAlt: "ServeNow",
    gap: "0px",
    marginTop: "52px",
    logoSpacing: "8px",
  },
);

const attrs = useAttrs();

const brandClass = computed(() => ["auth-brand", attrs.class]);

const brandStyle = computed(() => ({
  "--auth-brand-gap": props.gap,
  "--auth-brand-margin-top": props.marginTop,
  "--auth-title-color": props.titleColor || undefined,
  "--auth-subtitle-color": props.subtitleColor || undefined,
  "--auth-subtitle-size": props.subtitleSize || undefined,
  "--auth-logo-spacing": props.logoSpacing || undefined,
}));
</script>

<style scoped>
.auth-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0px;
  margin-top: var(--auth-brand-margin-top, 52px);
}

.auth-brand__logo-wrap {
  margin-bottom: var(--auth-logo-spacing, 8px);
}

.auth-brand__logo {
  width: 90px;
  height: 90px;
  border-radius: var(--radius-lg);
  background: #ffdfd5;
  -o-object-fit: contain;
  object-fit: contain;
  padding: 16px;
}

.auth-brand__title {
  font-weight: 800;
  color: var(--color-title);
  text-transform: capitalize;
  margin: 0;
}

.auth-brand__subtitle {
  color: var(--color-subtitle-light, #64748b);
  font-size: 14px;
  font-weight: 500;
}
</style>
